import net from "../utils/net";
export const getBannber = data => {
  return net.get("app/home/banner", data);
};

export const GetCode = data => {
  return net.get("app/getcode", data);
};

export const UserMobileLogin = data => {
  return net.get("app/login", data);
};


export const GetUserOverview = data => {
  return net.get("site/user/overview", data);
}


export const GetUserTrend = data => {
  return net.get("site/user/trend", data);
}

export const GetUserPro = data => {
  return net.get("site/user/pro", data);
}

export const GetUserInfo = data => {
  return net.get('app/userInfo', data)
}

export const SetUserInfo = data => {
  return net.post('app/userInfo', data)
}


export const GetUserStaff = data => {
  return net.get('site/user/staff', data)
}


export const GetScanConfig = data => {
  return net.get('/app/scan', data)
}

export const SetScanConfig = data => {
  return net.post('/app/scan', data)
}

export const StaffRecharge = data => {
  return net.post('site/user/recharge', data)
}


export const GetUserMoneyRecord = data => {
  return net.get('app/wallet/record', data)
}


export const ResetPassword = data => {
  return net.post('app/reset_password', data)
}

export const GetWechatUserInfo = data => {
  return net.get('site/login/wechat', data)
}


export const DingTalkLogin = data =>{
  return net.get('app/talk', data)
}